import { Typography } from "antd";

const AssignTo = ({
  text = "Назначить на меня",
  showAction = false,
  onChange,
  children,
}) => {
  return (
    <div style={{ position: "relative" }}>
      {children}

      {showAction && (
        <Typography.Link
          onClick={onChange}
          style={{
            fontSize: "12px",
            position: "absolute",
            right: 0,
            top: "3px",
          }}
        >
          {text}
        </Typography.Link>
      )}
    </div>
  );
};

export default AssignTo;
